import { render, staticRenderFns } from "./ColumnShippingType.vue?vue&type=template&id=4877c573&scoped=true"
import script from "./ColumnShippingType.vue?vue&type=script&lang=js"
export * from "./ColumnShippingType.vue?vue&type=script&lang=js"
import style0 from "./ColumnShippingType.vue?vue&type=style&index=0&id=4877c573&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877c573",
  null
  
)

export default component.exports